import { render, staticRenderFns } from "./index.vue?vue&type=template&id=33de35de&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33de35de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3029718028/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33de35de')) {
      api.createRecord('33de35de', component.options)
    } else {
      api.reload('33de35de', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=33de35de&scoped=true", function () {
      api.rerender('33de35de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/lifehikes/resource/index.vue"
export default component.exports